module.exports = __webpack_public_path__ + "img/voice-2.ce623cbe.svg";